// extracted by mini-css-extract-plugin
export var checkbox = "_8v-0";
export var circle = "_8v-3";
export var horizontalContainer = "_8v-7";
export var sm = "_8v-5";
export var switch0 = "_8v-2";
export var switchDisabled = "_8v-8";
export var switchEnabled = "_8v-1";
export var textSwitchContainer = "_8v-9";
export var textSwitchOption = "_8v-a";
export var textSwitchOptionSelected = "_8v-b";
export var verticalContainer = "_8v-6";
export var xs = "_8v-4";